<div class="contract-wrapper">
<table style="width: 100%;" border="0px">
  <tbody id="fordImage">
    <tr>
      <td>
        <div style="text-align: center;">

          <img style="width: 380px; height: 80px;" src="../../../assets/image/FordProtect_Blue_RGB_Hz_v1.png" alt="">
        </div>
        <div>

          <div class="title-terminos">
            <h5 class="title-padding">PLAN DE MANTENIMIENTO PREPAGO FORD PROTECT </h5>
            <h5 class="title-padding">CONTRATO Nº ({{ contractSignature.contractId }}) / ({{contractSignature.salesDate | date:"yyyy" }})</h5>
          </div>

          <div class="text-top">

            <p class="text-initial">
              Son partes, en este instrumento ("Contrato"),
              Ford Motor Colombia, S.A.S., con sede en la Carrera 7, Nro 113-43, Torre Samsung,
              Oficinas 1101-1102, Bogotá, D.C. ("Ford" o “Contratista”), denominadas
              colectivamente en adelante como "Partes" o, individualmente como "Parte".
            </p>

            <div>
              <h5 class="sub-title-top">Considerando que:</h5>
              <ol class="custom-list-roman">
                <li class="li-roman">
                  El Contratante ha comprado el vehículo Ford ({{ contractSignature.modelYearLine }});
                </li>
                <li class="li-roman">
                  Ford ofrece a sus clientes finales la posibilidad de comprar un plan de mantenimiento prepagado
                  opcional y
                  no obligatorio, llamado "Plan de mantenimiento prepagado Ford Protect" ("Plan");
                </li>
                <li class="li-roman">
                  Bajo los términos del Plan, el Contratante paga por adelantado las piezas y mano de obra que se
                  corresponde
                  con los servicios de mantenimiento que serán realizados en un Concesionario Ford autorizado del
                  territorio
                  nacional, de acuerdo con el plan contratado ({{ contractSignature.productName }}), pagado por el 
                  Contratante a la fecha de firma de este documento.
                </li>
              </ol>
            </div>

            <p class="text-second">
              Las Partes deciden firmar el CONTRATO Nro. ({{ contractSignature.contractId }}) /
              ({{contractSignature.salesDate | date:"yyyy" }}),
              EN LOS TÉRMINOS Y CONDICIONES INDICADOS A CONTINUACIÓN:
            </p>

          </div>

          <article class="article">

            <h5 class="sub-title title-negrito">
              PRIMERA CLÁUSULA – OBJETO
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                Plan de Mantenimiento Prepagado Ford Protect
                <ol class="custom-list-text-two">
                  <li class="li-text-two">
                    Las revisiones contratadas deben ser realizadas en cada intervalo de tiempo y/o kilometraje (km) conforme
                    está estipulado en la Guía de Servicio Ford o a indicación del Monitor Inteligente de Vida del Aceite
                    (IOLM*), si el vehículo viene equipado con este, en cualquier caso, lo que ocurra primero. Las operaciones
                    incluidas son cambio de aceite de motor, filtro de aceite, filtro de aire, filtro de combustible, filtro de
                    cabina, Fluido de frenos, Limpiador de frenos y Líquido limpiabrisas. El reemplazo se realizará únicamente a
                    los elementos específicamente indicados en el plan de mantenimiento de la revisión respectiva.
                  </li>
                  <li class="li-text-two-sub">
                    Las revisiones también incluyen la mano de obra para todas las inspecciones y controles previstos en la
                    tabla de Mantenimiento y Lubricación de la cartilla de mantenimiento, correspondiente a las revisiones.
                  </li>
                  <li class="li-text-two-sub">
                    *Si el vehículo está equipado con el IOLM, se mostrará un mensaje en la pantalla de información,
                    dependiendo
                    del modo de uso de este. Esta indicación determina que debe realizarse el servicio de mantenimiento.
                  </li>
                  <li class="li-text-two">
                    1.1.1.
                    <span class="li-text-three">
                      Planes:
                    </span>
                  </li>
  
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect 1:</span> incluye los tres (3) primeros
                    servicios de mantenimiento del Vehículo previstos en la Guía de Servicio Ford correspondiente;
                  </li>
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect 2:</span> incluye tres (3)
                    servicios de mantenimiento del vehículo, que corresponden al 2do, 3ero y 4to previstos en la 
                    Guía de Servicio Ford correspondiente;
                  </li>
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect 3:</span> incluye tres (3)
                    servicios de mantenimiento del vehículo, que corresponden al 3ero, 4to y 5to previstos en la 
                    Guía de Servicio Ford correspondiente;
                  </li>
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect Silver: </span> incluye los
                    cinco (5) primeros servicios de mantenimiento del Vehículo previstos en la Guía de Servicio Ford correspondiente.
                  </li>
                </ol>
              </li>

              <li class="li-number">
                El propósito de este acuerdo es que el Contratante adquiera a su entera discreción y conveniencia, el
                Plan de
                Mantenimiento Prepagado Ford Protect para su Vehículo, que incluye piezas y mano de obra que
                proporcionarán los
                Concesionarios Ford autorizados en el territorio nacional.
              </li>

              <li class="li-number">
                El ingreso del Vehículo al Concesionario Ford de elección del Contratante para realizar las revisiones
                de
                mantenimiento periódicas dentro de los intervalos definidos es obligación de éste último y la misma es
                esencial
                para el funcionamiento correcto y seguro del Vehículo como para garantizar su mejor rendimiento y
                durabilidad.

                <ol class="custom-list-text-two">
                  <li class="li-text-two">
                    1.3.1.
                    <span class="li-text-three">
                      Tolerancia
                    </span>
                  </li>
                  <li class="li-text-two">
                    Tal como se establece en la Guía de Servicio Ford, la tolerancia máxima para realizar revisiones
                    periódicas
                    es de un (1) mes o 1.000 kms, tal como seguidamente se describe:
                  </li>
                </ol>
                <ul class="ul-ifem">
                  <li class="li-ifem">
                    Con relación al tiempo de uso: la tolerancia máxima es de 1 (un) mes para el tiempo definido. Ej.:
                    entre
                    el
                    mes 11 (once) y el 13 (trece) para el mantenimiento que se espera que ocurra a los 12 (doce) meses
                    de
                    uso;
                  </li>
                  <li class="li-ifem">
                    Con relación al kilometraje: la tolerancia máxima es de 1.000 km para el kilometraje definido. Por
                    ejemplo,
                    entre 15.000 y 17.000 km para el mantenimiento previsto a 16.000 km conducidos.
                  </li>
                </ul>

              </li>

              <li class="li-number">
                Tolerancia para Vehículos Integrados con Intelligent Oil Lifetime Monitor - IOLM: tal como se indica
                en la
                cartilla de garantía, la tolerancia para realizar el cambio de aceite será de dos mil (2.000)
                kilómetros
                después
                de emitida la alerta por parte del IOLM.

                <ol class="custom-list-text-two">
                  <li class="li-text-two">
                    <span class="title-negrito">Importante</span>
                  </li>
                  <li class="li-text-two">
                    Las operaciones deben llevarse a cabo de acuerdo con lo descrito en cada servicio. Si existe necesidad
                    de
                    sustitución o reparación de piezas distintas a las cubiertas en el Plan, el Asesor de Servicio del
                    Concesionario
                    lo comunicará al Contratante de forma previa a realizar la sustitución o reparación de las piezas, y
                    se realizará siempre que se cuente con la aprobación del Contratante.
                  </li>
                </ol>

              </li>

            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA SEGUNDA – UTILIZACIÓN DEL PLAN DE MANTENIMIENTO PREPAGADO FORD PROTECT
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                Para la utilización del Plan contratado en la Cláusula 1.1., el Contratante deberá escoger el
                Concesionario
                Ford de su preferencia y agendar la cita del servicio. La lista de concesionarios Ford se puede
                encontrar en el
                sitio <a class="a-edit-blue" href="http://www.ford.com.co" target="_blank"
                  rel="noopener noreferrer">www.ford.com.co</a>. Ninguno de los planes descritos podrá ser aplicados y/o
                usados en
                concesionarios y/o
                talleres que no se encuentren en la lista oficial emitida por Ford.

              </li>
              <li class="li-number">
                El Contratante deberá asistir al Concesionario Ford elegido con la licencia de conducción y la Tarjeta
                de
                Propiedad del vehículo.
              </li>
              <li class="li-number">
                El tiempo de prestación del servicio por parte del Concesionario Ford elegido puede variar de acuerdo
                con el
                flujo de servicios en curso en la fecha programada por el Contratante.
              </li>
              <li class="li-number">
                Ford no es responsable y no reconocerá ningún costo y/o gasto incurrido en (i) servicios realizados
                fuera de los
                Concesionarios Ford autorizados en el territorio nacional, y (ii) servicios prestados fuera del alcance
                estricto
                previsto en este Contrato.
              </li>
              <li class="li-number">
                En caso de dudas sobre los servicios y productos recomendados para el mantenimiento del Vehículo, tanto
                en la
                Guía de Servicio Ford como en el Manual del Propietario. En caso de diferencias entre la Guía de
                Servicio Ford y
                este Contrato, el Contratante es consciente de que el Plan incluye únicamente los servicios aquí
                descritos.
              </li>
              <li class="li-number">
                El Plan está vinculado al número de chasis del Vehículo y no se disociará del mismo en caso de venta del
                Vehículo por parte del Contratante a terceros.
              </li>
              <li class="li-number">
                El tercero que adquiera el Vehículo del Contratante podrá realizar los servicios restantes aún no
                ejecutados en
                el Plan, siempre y cuando el Contrato esté vigente y se respeten los intervalos de tiempo y kilómetros
                (km)
                recorridos.
              </li>
              <li class="li-number">
                En caso de robo, hurto o pérdida total del Vehículo (a probar mediante denuncia policial y/o
                documentación del
                seguro), Ford devolverá el importe correspondiente a los servicios contratados que no se hayan
                realizado.
              </li>
              <li class="li-number">
                El Contratista que no realice alguno de los servicios previstos en el Plan dentro de la Vigencia de este
                Contrato y de acuerdo con los intervalos de tiempo y kilómetros (km) recorridos establecidos, no podrá
                realizar
                el servicio perdido fuera del período estipulado. Los servicios posteriores, siempre que estén cubiertos
                en el
                Plan contratado, podrán realizarse normalmente.
                <ol class="custom-list-text-two">
                  <li class="li-text-two">
                    2.9.1.
                    <ol class="custom-list-text-for">
                      <li class="li-text-for">
                        Independientemente de la contratación del Plan y respectivo pago anticipado por las piezas y
                        servicios
                        contratados, la no realización de alguna de las revisiones previstas en el Plan según los
                        intervalos de
                        tiempo, kilómetros (km) recorridos o indicación del Monitor Inteligente de Vida del Aceite (si
                        está
                        equipado con este) establecido en este contrato , y, así mismo, la no realización de revisiones
                        periódicas
                        tras la finalización del Plan, de acuerdo con los intervalos de tiempo y kilómetros (km)
                        recorridos según
                        el Manual del Propietario del Vehículo, puede causar la cancelación de la garantía del Vehículo,
                        así como
                        las demás premisas de cancelación previstas en la Guía de Servicio Ford.
                      </li>
                    </ol>
                  </li>
                </ol>
              </li>
            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA TERCERA – PRECIO
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                En el precio del Plan contratado se incluye la mano de obra y repuestos de las operaciones a realizar en
                los
                intervalos de tiempo y kilómetros (km) recorridos - también indicados en este contrato - y según lo
                recomendado
                por la Guía de Servicio Ford. Se entiende expresamente que cualquier operación o pieza adicional no
                contemplada
                como parte del Plan contratado, debe pagarse por separado directamente al Concesionario Ford donde se
                está
                realizando el servicio de mantenimiento, de acuerdo con las condiciones negociadas con el mismo.
              </li>
              <li class="li-number">
                <span class="span-underlined-dashed">El monto a pagar</span> por el Contratante con motivo de la
                contratación
                del Plan incluye todos los costos y gastos relacionados con impuestos, tasas, tarifas o cualquier otro
                que pueda
                caer dentro del alcance de este Contrato.

              </li>
            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA CUARTA - DURACIÓN Y RESCISIÓN
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                Vigencia: El presente Contrato entrará en vigor a partir de la fecha de emisión de la factura de venta
                del Vehículo, por los siguientes períodos:
                <ol class="custom-list-text-two">
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect Blue (1, 2, 3, 4):</span>
                    36 (treinta y seis) meses o 48.000 km, o al finalizar los 3(tres) servicios contratados, lo que ocurra primero 
                    ("Período de Vigencia");
                  </li>
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect Silver (1, 4):</span>
                    60 (sesenta) meses o al alcanzar el Vehículo un recorrido de 80.000 km, o al finalizar los 5 (cinco) servicios 
                    contratados, lo que ocurra primero ("Periodo de Vigencia");
                  </li>
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect Gold (1, 4):</span>
                    84 (ochenta y cuatro) meses o al alcanzar el Vehículo un recorrido de 112.000 km, o al finalizar los 7 (siete) 
                    servicios contratados, lo que ocurra primero ("Periodo de Vigencia");
                  </li>
                  <li class="li-text-two">
                    <span class="title-negrito"> Mantenimiento Prepagado Ford Protect Diamond:</span>
                    120 (ciento veinte) meses o al alcanzar el Vehículo un recorrido de 160.000 km, o al finalizar los 10 (diez) 
                    servicios contratados, lo que ocurra primero ("Periodo de Vigencia");
                  </li>
                </ol>
              </li>
              <li class="li-number">
                El inicio de la vigencia del Contrato y la respectiva activación del Plan estarán condicionados al pago total
                del precio correspondiente.
              </li>
              <li class="li-number">
                En ningún caso se prorrogará la vigencia del Contrato.
              </li>
            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA QUINTA – OTRAS OBLIGACIONES DE FORD
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                Ford, durante la vigencia de este Contrato, se compromete a:
              </li>
              <ol class="custom-list-alphabet" type="a">
                <li class="li-alphabet">
                  administrar, para el Contratante, los bienes y servicios relacionados con el Plan sujeto a este
                  Contrato;
                </li>
                <li class="li-alphabet">
                  garantizar la calidad de las piezas utilizadas y de la mano de obra de cada una de las operaciones
                  previstas
                  en este Contrato;
                </li>
                <li class="li-alphabet">
                  proporcionar al Contratante canales de servicio para resolver sus dudas, sugerencias y quejas sobre el
                  Plan;
                </li>
                <li class="li-alphabet">
                  atender, analizar y tomar las medidas apropiadas con respecto a todas y cada una de las reclamaciones
                  relacionadas con este Contrato, así como ponerse en contacto con el Concesionario Ford cuando sea
                  necesario;
                </li>
                <li class="li-alphabet">
                  cuidar, supervisar y ejecutar las medidas apropiadas para el cumplimiento del objeto de este Contrato;
                </li>
                <li class="li-alphabet">
                  garantizar que el Contratante pueda ejercer todos sus derechos previstos por la ley, en especial los
                  referidos
                  al tratamiento de datos personales; y
                </li>
                <li class="li-alphabet">
                  transferir únicamente los datos personales del Contratante que sean estrictamente necesarios para el
                  disfrute
                  del Plan a los Concesionarios Ford (es decir, nombre completo, Documento de identificación, correo
                  electrónico, teléfono de contacto, dirección y chasis del vehículo), asegurando que estos serán
                  eliminados,
                  tanto de la base de datos de Ford como del Concesionario Ford, una vez cese el uso de estos. Se
                  determina que
                  los datos personales pueden almacenarse en la Nube de Ford Motor Company, ubicada en los Estados
                  Unidos, de
                  manera segura y de acuerdo con las obligaciones legales aplicables; el dato del VIN quedará en la nube
                  exclusivamente para el análisis estadístico.
                </li>
              </ol>
            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA SEXTA – OTRAS OBLIGACIONES DEL CONTRATANTE
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                El Cliente se compromete a realizar los servicios periódicos de mantenimiento y a seguir todas las
                recomendaciones, cuidados y comprobaciones adicionales que se indiquen en el Manual de Propietario y
                Guía de
                Servicio Ford.
              </li>
              <li class="li-number">
                El Cliente se compromete a mantener actualizados sus datos personales de contacto (nombre completo,
                número de
                identificación, correo electrónico, teléfonos de contacto, dirección) llamando a la línea de atención
                Ford para
                posibilitar futuros contactos de Ford estrictamente relacionados con este Contrato.
              </li>
            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA SÉPTIMA – ANTICORRUPCIÓN
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                Las partes se obligan a no realizar ninguna práctica corrupta. Considerando todo lo anterior, la parte
                incumplida libera a la parte cumplida de toda la responsabilidad derivada de cualquier responsabilidad
                por
                incumplimiento de la Ley, el profesionalismo, la ética, y la legislación aplicable.
              </li>
            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA OCTAVA - DISPOSICIONES GENERALES
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                Las Partes harán todo lo posible para tratar de resolver amistosamente todas las controversias que
                surjan de
                este Contrato. En caso de controversia, la Parte interesada en su resolución remitirá a la otra
                notificación por
                escrito con el fin de llevar a cabo negociaciones amistosas y de buena fe para resolverla lo antes
                posible.
              </li>
              <li class="li-number">
                Agotada la instancia amistosa referida en el numeral anterior, toda diferencia o controversia relativa
                al
                presente Contrato se resolverá por un tribunal arbitral que funcionará en el Centro de Arbitraje y
                Conciliación
                de la Cámara de Comercio de Bogotá, de acuerdo con las siguientes reglas: (1) El tribunal se sujetará a
                las
                reglas de procedimiento del Centro de Arbitraje y Conciliación de la Cámara de Comercio de Bogotá; (2)
                el
                tribunal arbitral estará integrado por un (1) árbitros designados de común acuerdo por las partes y, a
                falta de
                acuerdo, por el Centro de Arbitraje y Conciliación de la Cámara de Comercio de Bogotá, a solicitud de
                cualquiera
                de las partes; (3) El tribunal fallará en derecho, de conformidad con las leyes de la República de
                Colombia, con
                exclusión de sus leyes sobre conflicto de leyes; (4) El idioma del arbitraje será el español y la sede
                del
                tribunal será la ciudad de Bogotá D.C.
              </li>
              <li class="li-number">
                Las Partes también declaran que reconocen como válidas las firmas electrónicas realizadas.
              </li>
              <li class="li-number">
                A efectos tributarios se entenderá siempre como comercializados los servicios objeto de este contrato en
                la ciudad de Bogotá, D.C.
              </li>
            </ol>

            <h5 class="sub-title title-negrito">
              CLÁUSULA NOVENA – AUTORIZACIÓN PARA EL TRATAMIENTO DEL DATO.
            </h5>

            <ol class="custom-list-number">
              <li class="li-number">
                De conformidad con lo dispuesto en la Ley Estatutaria 1581 de 2012 y sus Decretos reglamentarios, Ford
                en
                calidad de responsable del tratamiento de los datos personales, informa que el manejo y administración
                de la
                información de carácter personal recolectada con ocasión de la prestación de los servicios del Plan de
                Mantenimiento Prepagado Ford Protect, estará regida por la Política de Privacidad de Ford disponible en
                la
                página web <a class="a-edit-blue" href="http://www.ford.com.co" target="_blank"
                  rel="noopener noreferrer">www.ford.com.co</a>.
              </li>
              <li class="li-number">
                Al proporcionarnos sus datos personales, usted en calidad de Contratante y titular de los datos
                personales, entiende y acepta que estos serán utilizados para los siguientes fines:
              </li>
              <ul class="ul-circle">
                <li class="li-circle">
                  Remitir a los concesionarios de la red Ford, para que estos puedan prestarles los servicios
                  contratados bajo el Plan de Mantenimiento Prepagado Ford Protect.
                </li>
                <li class="li-circle">
                  Realizar directamente o través de terceros encuestas de satisfacción sobre el funcionamiento y
                  prestación de servicio contratados bajo el Plan de Mantenimiento Prepagado Ford Protect.
                </li>
                <li class="li-circle">
                  Tramitar solicitudes como peticiones, quejas y reclamos.
                </li>
              </ul>
              <li class="li-number">
                El tratamiento realizado por Ford incluye la recolección, el almacenamiento, el uso, el procesamiento,
                circulación, supresión, actualización, transmisión y/o transferencia a cualquier entidad pública,
                compañía privada, compañía relacionada o empresa que subcontratemos para el desarrollo de nuestro objeto
                social, incluyendo la contratación de servicios en la nube en Colombia y/u otros países que
                eventualmente pudieran considerarse como destinos sin los mismos estándares de protección de acuerdo lo
                señalado por la Autoridad Colombiana de Protección de Datos.
              </li>
              <li class="li-number">
                Recuerde que usted, como Contratante y titular de los datos personales, tiene derecho a:
              </li>
              <ul class="ul-circle">
                <li class="li-circle">
                  Acceder en forma gratuita a los datos proporcionados que hayan sido objeto de tratamiento;
                </li>
                <li class="li-circle">
                  Conocer, actualizar y rectificar su información frente a datos parciales, inexactos, incompletos,
                  fraccionados, que induzcan a error, o aquellos cuyo tratamiento esté prohibido o no haya sido
                  autorizado;
                </li>
                <li class="li-circle">
                  Solicitar prueba de la autorización otorgada;
                </li>
                <li class="li-circle">
                  Presentar ante la Superintendencia de Industria y Comercio quejas por infracciones a lo dispuesto en
                  la normatividad vigente;
                </li>
                <li class="li-circle">
                  Revocar la autorización y/o solicitar la supresión del dato, siempre que no exista un deber legal o
                  contractual que impida eliminarlos; y
                </li>
                <li class="li-circle">
                  Abstenerse de responder a las preguntas sobre datos sensibles.
                </li>
              </ul>
            </ol>

            <ol class="custom-list-text">
              <li class="li-text">
                Para el ejercicio de sus derechos podrá utilizar los canales dispuestos por Ford comunicándose
                electrónicamente al correo electrónico <a class="a-edit-blue" href="mailto:contacol&#64;ford.com" target="_blank"
                rel="noopener noreferrer">contacol&#64;ford.com</a>.
              </li>
            </ol>
            
          </article>
          <p class="custom-text-data">
            
             <span>{{country}},&ensp;</span> 
              {{ contractSignature.salesDate | date:'dd' }} de
              {{ month }} de
              {{ contractSignature.salesDate | date:'yyyy' }}.            
          </p>

        </div>
      </td>
    </tr>
  </tbody>
</table>
</div><!-- /.contract-wrapper -->